import angular from 'angular';
import constants from 'app/constants';
import {
  assetDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './add-type-presets.controller';
import template from './add-type-presets-dialog.html';
import presetsValidator, { name as presetsValidatorName } from './unique-asset-type-presets.validator.directive';
import prefixMessagesTpl from './prefix.messages.html';

class dialogService {
  getOptions($event, {
    customerId, asset,
  }) {
    return {
      controller,
      controllerAs: 'typePresetsDialogVM',
      locals: {
        customerId,
        asset,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.asset.addTypePresetsDialog', [
  alerts,
  assetDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .directive(presetsValidatorName, presetsValidator)
  .service('addTypePresetsDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('prefix.messages.html', prefixMessagesTpl);
  })
  .name;
